import { Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useDirection } from '~/hooks/i18nHooks';

function InitialInformation(props: any) {
  const { data } = props;
  const { t } = useTranslation('ksaApplication');
  const dir = useDirection();
  const owners = data?.managers?.managers
    ?.concat(data?.shareholders?.individuals)
    ?.filter((item: any) => item?.personalData?.isAuthorizedSignatory);
  return (
    <Container dir={dir}>
      {!!Object?.keys(data?.thiqahFullInfo || {})?.length && (
        <div className="data-container">
          <Typography.Paragraph>{t('Initial Information')}</Typography.Paragraph>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">
              {t('Company CR Number or Unified Number')}
            </Typography.Paragraph>
          </RowContainer>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">{t('National ID/Iqama')}</Typography.Paragraph>
          </RowContainer>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">{t('Mobile Number')}</Typography.Paragraph>
          </RowContainer>
        </div>
      )}
      {!!Object?.keys(data?.companyInformation || {})?.length && (
        <div style={{ marginTop: 36 }}>
          <Typography.Paragraph>{t('Business Details')}</Typography.Paragraph>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">{t('Company Brand Name')}</Typography.Paragraph>
          </RowContainer>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">{t('Company Website')}</Typography.Paragraph>
          </RowContainer>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">
              {t('Main Business Nature')}
            </Typography.Paragraph>
          </RowContainer>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">
              {t('Tax Registration Number')}
            </Typography.Paragraph>
          </RowContainer>
        </div>
      )}
      {!!owners?.length && (
        <div style={{ marginTop: 36 }}>
          <Typography.Paragraph>{t('Business Owner')}</Typography.Paragraph>
          {owners?.map((item: any) => (
            <RowContainer dir={dir} key={item?.personalData?.fullName}>
              <CheckCircleOutlined className="checkIcon" />
              <Typography.Paragraph className="text">
                {t(item?.personalData?.fullName)}
              </Typography.Paragraph>
            </RowContainer>
          ))}
        </div>
      )}

      {!!Object?.keys(data?.bankAccount || {})?.length && (
        <div style={{ marginTop: 36 }}>
          <Typography.Paragraph>{t('Bank Details')}</Typography.Paragraph>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">{t('IBAN Number')}</Typography.Paragraph>
          </RowContainer>
        </div>
      )}
      {!!data?.contract?.length && (
        <div style={{ marginTop: 36 }}>
          <Typography.Paragraph>{t('Agreement')}</Typography.Paragraph>
          <RowContainer dir={dir}>
            <CheckCircleOutlined className="checkIcon" />
            <Typography.Paragraph className="text">{t('Uploaded')}</Typography.Paragraph>
          </RowContainer>
        </div>
      )}
    </Container>
  );
}

const Container = styled.div`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  .data-container {
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;    
  }    
    .ant-typography{
    color:#4A4A4A;
    }
`;
const RowContainer = styled.div<any>`
  display: flex;
  align-items: center; /* this vertically centers the children */
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  .text {
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    margin: 0; /* remove default margins */
    line-height: 1.2; /* adjust as needed */
    /* optionally: make sure the text container is a flex item too */
    display: flex;
    align-items: center;    
  }

  .checkIcon {
    color: #0069b1;
    margin-right: 8px;
    margin-left: 8px;
  }

  margin-bottom: 12px;
`;

export default InitialInformation;
